















































































































































import INoticeOfLossDetail from '@/store/models/INoticeOfLossDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IOutboundDeliveryNotesDetail from '@/store/models/IOutboundDeliveryNotesDetail';
import OutboundsNoticeOfLossDeliveryNotesDetailSelector from '@/components/selectors/NoticeOfLoss/OutboundsNoticeOfLossDeliveryNotesDetailSelector.vue';
@Component({
    components: {
        Snackbar,
        OutboundsNoticeOfLossDeliveryNotesDetailSelector
    }
})
export default class OutboundsNoticeOfLossDetailSelector extends Vue {
    searchNoticeOfLossDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'idPallet';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'ListPalletName',
            align: 'start',
            value: 'listPalletName'
        },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Actions', value: 'actions' }
    ];
    editedIndex : number = -1;
    editedItem : INoticeOfLossDetail = {
        id: "",
        idNoticeOfLoss: "",
        idDeliveryNoteDetail: "",
        idListPallet: "",
        listPalletName: "",
        idPallet: "",
        casesPerPallet: 0,
        goodsPerCase: 0,
        totalGoods: 0
    }
    defaultItem : INoticeOfLossDetail = {
        id: "",
        idNoticeOfLoss: "",
        idDeliveryNoteDetail: "",
        idListPallet: "",
        listPalletName: "",
        idPallet: "",
        casesPerPallet: 0,
        goodsPerCase: 0,
        totalGoods: 0
    }

    @Prop({ type: Array, required: true })
    NoticeOfLossDetailList !: INoticeOfLossDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesDetailList !: IOutboundDeliveryNotesDetail[];
    @Prop()
    Loading !: boolean;

    selectedNoticeOfLossDetail : INoticeOfLossDetail[] = [];
    selectedOutboundsDeliveryNotesDetail : IOutboundDeliveryNotesDetail[] | null = null;
    get formTitle() { return this.editedIndex === -1 ? 'New Notice of loss detail' : 'Edit Notice of loss detail'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    getOutboundDeliveryNotesDetails() {
        this.selectedNoticeOfLossDetail = [];
        this.selectedOutboundsDeliveryNotesDetail = null;
        this.$emit('getOutboundDeliveryNotesDetails');
    }

    saveNoticeOfLossDetail () {
        let noticesOfLossDetails : INoticeOfLossDetail[] = [];
        if (this.selectedOutboundsDeliveryNotesDetail === null) {
            this.showMessageWarning('Please select a stock to save');
        } else {
            this.selectedOutboundsDeliveryNotesDetail.forEach(p => {
                let noticeOfLossDetail : INoticeOfLossDetail = {} as INoticeOfLossDetail;
                noticeOfLossDetail.idDeliveryNoteDetail = p.id;
                noticeOfLossDetail.idListPallet = p.idListPallet;
                noticeOfLossDetail.listPalletName = p.palletName;
                noticeOfLossDetail.idPallet = p.idPallet;
                noticeOfLossDetail.casesPerPallet = p.casesPerPallet;
                noticeOfLossDetail.goodsPerCase = p.goodsPerCase;
                noticeOfLossDetail.totalGoods = p.totalGoods;
                noticesOfLossDetails.push(noticeOfLossDetail);
            });
            this.$emit('saveNoticeOfLossDetail', noticesOfLossDetails);
            this.close();
        }
    }

    deleteNoticeOfLossDetail (noticeOfLossDetail: INoticeOfLossDetail) {
        this.$emit('deleteNoticeOfLossDetail', noticeOfLossDetail);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item : INoticeOfLossDetail) : void {
        let index : number = this.selectedNoticeOfLossDetail.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedNoticeOfLossDetail = [item];
        } else {
            let noticeOfLossDetail = this.selectedNoticeOfLossDetail.find(w => w.id === item.id);
            if (!noticeOfLossDetail) {
                this.selectedNoticeOfLossDetail = [];
            }
        }
    }
    get totalPalletsSelected(): number {
        return this.selectedOutboundsDeliveryNotesDetail ? this.selectedOutboundsDeliveryNotesDetail.length : 0;
    }

    get totalCasesSelected(): number {
        if (!this.selectedOutboundsDeliveryNotesDetail) return 0;
        return this.selectedOutboundsDeliveryNotesDetail.reduce((sum, item) => sum + (item.casesPerPallet || 0), 0);
    }

    get totalGoodsSelected(): number {
        if (!this.selectedOutboundsDeliveryNotesDetail) return 0;
        return this.selectedOutboundsDeliveryNotesDetail.reduce((sum, item) => sum + (item.totalGoods || 0), 0);
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
